import { render, staticRenderFns } from "./config-custom-newznab.vue?vue&type=template&id=5c3e11ee&scoped=true&"
import script from "./config-custom-newznab.vue?vue&type=script&lang=js&"
export * from "./config-custom-newznab.vue?vue&type=script&lang=js&"
import style0 from "./config-custom-newznab.vue?vue&type=style&index=0&id=5c3e11ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e11ee",
  null
  
)

export default component.exports